export class ReviewResponseModel {
    engagementId: number;
    reviewResponseHtml: string;
    createdBy: string;
    workItemId: string;
    workspaceId: string;
    isUpdatedQuestionnaire: boolean;
}
